module.exports = __webpack_public_path__ + "img/scene6.529b9f9e.png";